import api from 'api';
import { MenuItems } from 'records/MenuItem';

export const MENU_ITEMS_ASYNC_ACTION_START = 'MENU_ITEMS_ASYNC_ACTION_START';
export const MENU_ITEMS_ASYNC_ACTION_ERROR = 'MENU_ITEMS_ASYNC_ACTION_ERROR';
export const MENU_ITEMS_ASYNC_UPDATE_SUCCESS = 'MENU_ITEMS_ASYNC_UPDATE_SUCCESS';
export const MENU_ITEMS_UPDATE_ACTION_SUCCESS = 'MENU_ITEMS_UPDATE_ACTION_SUCCESS';
export const MENU_ITEMS_CATEGORY_UPDATE_ACTION_SUCCESS = 'MENU_ITEMS_CATEGORY_UPDATE_ACTION_SUCCESS';
export const MENU_ITEMS_CATEGORY_UPDATE = 'MENU_ITEMS_CATEGORY_UPDATE';
export const MENU_ITEMS_DRAGGABLE_UPDATE = 'MENU_ITEMS_DRAGGABLE_UPDATE';
export const MENU_ITEMS_OPTIONS_UPDATE = 'MENU_ITEMS_OPTIONS_UPDATE';
export const MENU_ITEMS_UPDATE_ORDINALS_SUCCESS = 'MENU_ITEMS_UPDATE_ORDINALS_SUCCESS';
export const MENU_ITEMS_ORDINALS_DEBOUNCE = 'MENU_ITEMS_ORDINALS_DEBOUNCE';
export const MENU_ITEMS_RESET_STATE = 'MENU_ITEMS_RESET_STATE';

function menuItemsAsyncActionStart() {
  return {
    type: MENU_ITEMS_ASYNC_ACTION_START,
  };
}

function menuItemsAsyncActionError(error) {
  return {
    type: MENU_ITEMS_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemsAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEMS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function menuItemCategoriesUpdateSuccess(data) {
  return {
    type: MENU_ITEMS_CATEGORY_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function menuItemsUpdateOrdinalsSuccess() {
  return {
    type: MENU_ITEMS_UPDATE_ORDINALS_SUCCESS,
  };
}

export function updateMenuItems(data) {
  return {
    type: MENU_ITEMS_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function updateMenuItemsByCategory(data) {
  return {
    type: MENU_ITEMS_CATEGORY_UPDATE,
    data,
  };
}

export function updateDraggableMenuItems(data) {
  return {
    type: MENU_ITEMS_DRAGGABLE_UPDATE,
    data,
  };
}

export function updateMenuItemOptions(options) {
  return {
    type: MENU_ITEMS_OPTIONS_UPDATE,
    options,
  };
}

export function resetMenuItemsState() {
  return {
    type: MENU_ITEMS_RESET_STATE,
  };
}

export function getMenuItems(menuId) {
  return (dispatch, getState) => {
    dispatch(menuItemsAsyncActionStart());
    return api.request(`menuItem/list?menuId=${ menuId }`, 'get')
    .then((data) => {
      dispatch(menuItemsAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemsAsyncActionError('Unable to get Menu Items'));
      throw (err);
    });
  };
}

export function getDesignMenuItems(menuId) {
  return (dispatch, getState) => {
    dispatch(menuItemsAsyncActionStart());
    return api.request(`menuItem/listOfDesignMenuItems?menuId=${ menuId }`, 'get')
    .then((data) => {
      dispatch(menuItemsAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemsAsyncActionError('Unable to get Menu Items'));
      throw (err);
    });
  };
}

export function getMenuItemsByCategory(menuId, categoryId) {
  return (dispatch, getState) => {
    
    return api.request(`menuItem/list?menuId=${ menuId }&categoryId=${ categoryId }`, 'get')
    .then((data) => {
      dispatch(menuItemCategoriesUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemsAsyncActionError('Unable to get Menu Items'));
      throw (err);
    });
  };
}

export function updateMenuItemsOrdinal(orderedMenuItems) {
  const thunk = (dispatch, getState) => {
    
    return api.request('menuItem/updateOrdinalsByIndex', 'put', orderedMenuItems)
    .then((data) => {
      dispatch(menuItemsUpdateOrdinalsSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuItemsAsyncActionError('Unable to order Menu Items'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: MENU_ITEMS_ORDINALS_DEBOUNCE,
    },
  };
  return thunk;
}

export function createMenuItemsFromRecipesAsync(menuItem) {
  return (dispatch, getState) => {
    dispatch(menuItemsAsyncActionStart());
    return api.request('menuItem/from-recipeList', 'post', menuItem)
    .then((data) => {
      dispatch(menuItemCategoriesUpdateSuccess(data));
      return MenuItems(data);
    })
    .catch((err) => {
      dispatch(menuItemsAsyncActionError('Unable to create menu items from recipes'));
      throw (err);
    });
  };
}
